// One controller per dialog, shared by static and JSON-generated modal content.
const dialogs = new WeakMap();
export function prepareDialog(dialog) {
  if (!dialog || dialogs.has(dialog)) return;
  const state = { trigger: null };
  dialogs.set(dialog, state);
  dialog.addEventListener('close', () => {
    document.body.classList.toggle('modal-open', !!document.querySelector('dialog[open]'));
    if (state.trigger?.isConnected) state.trigger.focus({ preventScroll: true });
    state.trigger = null;
  });
  dialog.addEventListener('click', (event) => {
    const closeButton = event.target.closest?.('.c-button__modal__close, .c-button__close');
    if (closeButton && closeButton.closest('dialog') === dialog) {
      event.preventDefault();
      dialog.close();
    } else if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      const outside =
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom;
      if (outside) dialog.close();
    }
  });
}
export function openDialog(dialog, trigger) {
  if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
  prepareDialog(dialog);
  dialogs.get(dialog).trigger = trigger || document.activeElement;
  dialog.showModal();
  document.body.classList.add('modal-open');
}
